module.exports = __webpack_public_path__ + "static/media/service-purple.3ec17bbd.svg";